var _path, _rect, _circle, _path2, _path3, _path4, _path5, _circle2, _circle3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path6, _path7, _path8, _path9, _path10, _path11, _ellipse, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmptyStateDashboard = function SvgEmptyStateDashboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 145,
    viewBox: "0 0 176 145",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0488 8.76025C-5.9352 24.4333 -1.4213 61.507 4.24212 78.0843C12.2376 97.6754 28.4006 119.048 47.7172 127.314C70.0213 136.859 103.502 134.22 121.675 131.333C137.483 128.821 167.749 118.774 173.145 109.23C178.541 99.6852 177.959 81.0985 156.472 72.5587C138.776 65.5259 125.989 39.4031 111.681 22.8266C97.3718 6.25018 57.0287 -10.8311 22.0488 8.76025Z",
    fill: "#EBEFF3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 19.5,
    width: 148,
    height: 101,
    rx: 2.5,
    fill: "white",
    stroke: "#E4E4E4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 23,
    r: 1,
    fill: "#CE2030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99 48L111 50L120 56L130 48L141 52.5L150 51.5",
    stroke: "#CCE5D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87 28L87 118",
    stroke: "#E4E4E4",
    strokeOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159 70L15 70",
    stroke: "#E4E4E4",
    strokeOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M161 26L14 26",
    stroke: "#E4E4E4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 23,
    r: 1,
    fill: "#64C67C"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 23,
    r: 1,
    fill: "#FFD57C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 46,
    width: 6,
    height: 9,
    fill: "#F4E09B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 55,
    width: 6,
    height: 6,
    fill: "#F3CC56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 54,
    width: 6,
    height: 7,
    fill: "#F3CC56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 46,
    width: 6,
    height: 15,
    fill: "#F3CC56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 53,
    width: 6,
    height: 8,
    fill: "#F3CC56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 51,
    width: 6,
    height: 10,
    fill: "#F3CC56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 37,
    width: 6,
    height: 17,
    fill: "#F4E09B"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 33,
    width: 6,
    height: 13,
    fill: "#F4E09B"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 42,
    width: 6,
    height: 11,
    fill: "#F4E09B"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 34,
    width: 6,
    height: 17,
    fill: "#F4E09B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5 56.5L108.5 45L119.5 50L129.5 41.5L139.5 47.5L150 40",
    stroke: "#B1E3C8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50 82C51.7072 82 53.3977 82.3363 54.9749 82.9896C56.5521 83.6429 57.9852 84.6005 59.1924 85.8076C60.3996 87.0148 61.3571 88.4479 62.0104 90.0251C62.6637 91.6023 63 93.2928 63 95C63 96.7072 62.6637 98.3977 62.0104 99.9749C61.3571 101.552 60.3996 102.985 59.1924 104.192C57.9852 105.4 56.5521 106.357 54.9749 107.01C53.3977 107.664 51.7072 108 50 108C48.2928 108 46.6023 107.664 45.0251 107.01C43.4479 106.357 42.0148 105.4 40.8076 104.192C39.6004 102.985 38.6429 101.552 37.9896 99.9749C37.3363 98.3977 37 96.7072 37 95C37 93.2928 37.3363 91.6023 37.9896 90.0251C38.6429 88.4479 39.6005 87.0148 40.8076 85.8076C42.0148 84.6005 43.4479 83.6429 45.0251 82.9896C46.6023 82.3363 48.2928 82 50 82L50 82Z",
    stroke: "#E3E6EB",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6437 82.0049C52.2486 81.9335 54.8149 82.6466 57.0096 84.0517C59.2043 85.4568 60.926 87.4891 61.9514 89.8849C62.9767 92.2806 63.2584 94.9292 62.7599 97.487C62.2613 100.045 61.0056 102.394 59.1555 104.229C57.3055 106.064 54.9466 107.301 52.3848 107.779C49.8231 108.257 47.1768 107.955 44.7894 106.91C42.4019 105.866 40.3835 104.128 38.996 101.922C37.6084 99.7159 36.9159 97.144 37.0082 94.5397",
    stroke: "url(#paint0_linear)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M124.5 109L109.345 82L139.655 82L124.5 109Z",
    fill: "#FF7070"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M124.5 109L113 88.5L136 88.5L124.5 109Z",
    fill: "#FFA4A4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M124.5 109L118 97.5L131 97.5L124.5 109Z",
    fill: "#FFC8C8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88,
    cy: 142.5,
    rx: 53,
    ry: 2.5,
    fill: "#EBEFF3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 35,
    y1: 102.5,
    x2: 64.2521,
    y2: 102.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88C5FF"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyStateDashboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty-state-dashboard.41a8c925.svg";
export { ForwardRef as ReactComponent };